var cov_1xu0mfw308 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/Result.tsx",
      hash = "79974bdbbf7e01420a49916efd3abd782444e53a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/Result.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 21
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 28
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "2": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 16
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 52
        }
      },
      "5": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "6": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 66
        }
      },
      "7": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 66
        }
      },
      "8": {
        start: {
          line: 30,
          column: 29
        },
        end: {
          line: 30,
          column: 66
        }
      },
      "9": {
        start: {
          line: 34,
          column: 40
        },
        end: {
          line: 34,
          column: 50
        }
      },
      "10": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 42
        }
      },
      "11": {
        start: {
          line: 35,
          column: 19
        },
        end: {
          line: 35,
          column: 42
        }
      },
      "12": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 30
        }
      },
      "13": {
        start: {
          line: 43,
          column: 24
        },
        end: {
          line: 43,
          column: 34
        }
      },
      "14": {
        start: {
          line: 44,
          column: 105
        },
        end: {
          line: 44,
          column: 115
        }
      },
      "15": {
        start: {
          line: 45,
          column: 22
        },
        end: {
          line: 45,
          column: 104
        }
      },
      "16": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 16
          },
          end: {
            line: 13,
            column: 17
          }
        },
        loc: {
          start: {
            line: 13,
            column: 28
          },
          end: {
            line: 13,
            column: 29
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 40
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 17
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 18
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 33
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 40
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 38
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 11
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 42
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 66
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 66
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 42
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 42
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 52
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 44,
            column: 27
          },
          end: {
            line: 44,
            column: 52
          }
        }],
        line: 44
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 48
          },
          end: {
            line: 45,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 48
          },
          end: {
            line: 45,
            column: 59
          }
        }, {
          start: {
            line: 45,
            column: 63
          },
          end: {
            line: 45,
            column: 77
          }
        }],
        line: 45
      },
      "4": {
        loc: {
          start: {
            line: 45,
            column: 79
          },
          end: {
            line: 45,
            column: 103
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 79
          },
          end: {
            line: 45,
            column: 86
          }
        }, {
          start: {
            line: 45,
            column: 90
          },
          end: {
            line: 45,
            column: 103
          }
        }],
        line: 45
      },
      "5": {
        loc: {
          start: {
            line: 51,
            column: 9
          },
          end: {
            line: 60,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 9
          },
          end: {
            line: 51,
            column: 28
          }
        }, {
          start: {
            line: 52,
            column: 10
          },
          end: {
            line: 59,
            column: 14
          }
        }],
        line: 51
      },
      "6": {
        loc: {
          start: {
            line: 52,
            column: 56
          },
          end: {
            line: 52,
            column: 101
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 52,
            column: 72
          },
          end: {
            line: 52,
            column: 81
          }
        }, {
          start: {
            line: 52,
            column: 84
          },
          end: {
            line: 52,
            column: 101
          }
        }],
        line: 52
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 66,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 62,
            column: 20
          }
        }, {
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 65,
            column: 14
          }
        }],
        line: 62
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/Result.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { uploadClass } from './styles';
import icons from '../icons';
import RemoveConfirm from './RemoveConfirm';
import { getDirectionClass } from '../utils/classname';
var DefaultProps = (cov_1xu0mfw308.s[0]++, {
  renderResult: function renderResult(a) {
    cov_1xu0mfw308.f[0]++;
    cov_1xu0mfw308.s[1]++;
    return a;
  },
  recoverAble: false
});

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Result, _PureComponent);

  var _super = _createSuper2(Result);

  function Result(props) {
    var _this;

    _classCallCheck(this, Result);

    cov_1xu0mfw308.f[1]++;
    cov_1xu0mfw308.s[2]++;
    _this = _super.call(this, props);
    cov_1xu0mfw308.s[3]++;
    _this.state = {
      confirm: false
    };
    cov_1xu0mfw308.s[4]++;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    cov_1xu0mfw308.s[5]++;
    _this.handleRecover = _this.handleRecover.bind(_assertThisInitialized(_this));
    cov_1xu0mfw308.s[6]++;
    _this.handleConfirmChange = _this.handleConfirmChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Result, [{
    key: "handleRemove",
    value: function handleRemove() {
      cov_1xu0mfw308.f[2]++;
      cov_1xu0mfw308.s[7]++;

      if (this.props.onRemove) {
        cov_1xu0mfw308.b[0][0]++;
        cov_1xu0mfw308.s[8]++;
        this.props.onRemove(this.props.index);
      } else {
        cov_1xu0mfw308.b[0][1]++;
      }
    }
  }, {
    key: "handleRecover",
    value: function handleRecover() {
      cov_1xu0mfw308.f[3]++;

      var _ref = (cov_1xu0mfw308.s[9]++, this.props),
          onRecover = _ref.onRecover,
          value = _ref.value,
          index = _ref.index;

      cov_1xu0mfw308.s[10]++;

      if (onRecover) {
        cov_1xu0mfw308.b[1][0]++;
        cov_1xu0mfw308.s[11]++;
        onRecover(index, value);
      } else {
        cov_1xu0mfw308.b[1][1]++;
      }
    }
  }, {
    key: "handleConfirmChange",
    value: function handleConfirmChange(confirm) {
      cov_1xu0mfw308.f[4]++;
      cov_1xu0mfw308.s[12]++;
      this.setState({
        confirm: confirm
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_1xu0mfw308.f[5]++;

      var _ref2 = (cov_1xu0mfw308.s[13]++, this.state),
          confirm = _ref2.confirm;

      var _ref3 = (cov_1xu0mfw308.s[14]++, this.props),
          _ref3$renderResult = _ref3.renderResult,
          renderResult = _ref3$renderResult === void 0 ? (cov_1xu0mfw308.b[2][0]++, DefaultProps.renderResult) : _ref3$renderResult,
          value = _ref3.value,
          recoverAble = _ref3.recoverAble,
          showRecover = _ref3.showRecover,
          removeConfirm = _ref3.removeConfirm;

      var className = (cov_1xu0mfw308.s[15]++, uploadClass('view-value', (cov_1xu0mfw308.b[3][0]++, recoverAble) && (cov_1xu0mfw308.b[3][1]++, 'to-be-delete'), (cov_1xu0mfw308.b[4][0]++, confirm) && (cov_1xu0mfw308.b[4][1]++, 'view-active')));
      cov_1xu0mfw308.s[16]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 48,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass(getDirectionClass('text')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49,
            columnNumber: 9
          }
        }, renderResult(value)), (cov_1xu0mfw308.b[5][0]++, this.props.onRemove) && (cov_1xu0mfw308.b[5][1]++,
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('delete'),
          onClick: removeConfirm ? (cov_1xu0mfw308.b[6][0]++, undefined) : (cov_1xu0mfw308.b[6][1]++, this.handleRemove),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 52,
            columnNumber: 11
          }
        }, icons.Close,
        /*#__PURE__*/
        React.createElement(RemoveConfirm, {
          onVisibleChange: this.handleConfirmChange,
          confirm: removeConfirm,
          onRemove: this.handleRemove,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 54,
            columnNumber: 13
          }
        }))), (cov_1xu0mfw308.b[7][0]++, showRecover) && (cov_1xu0mfw308.b[7][1]++,
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('recover'),
          onClick: this.handleRecover,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 63,
            columnNumber: 11
          }
        }, icons.Recovery)))
      );
    }
  }]);

  return Result;
}(PureComponent);

Result.defaultProps = DefaultProps;
export default Result;